// removed by extract-text-webpack-plugin
module.exports = {"panelDatos_heading":"PanelDatos__panelDatos_heading___1lJst","tablaDatos":"PanelDatos__tablaDatos___2owUO","inputEmail":"PanelDatos__inputEmail___2m8V7","disminuir":"PanelDatos__disminuir___1CTOO","aumentar":"PanelDatos__aumentar___2qpSn"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/nominas/nominaIG/components/PanelDatos.css
// module id = 917
// module chunks = 0